import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  const services = [
    { label: 'Flex Printing & Design', to: '/print' },
    { label: 'Digital Marketing', to: '/services/digital-growth' },
    { label: 'Photography & Video', to: '/photography' },
    { label: 'Branding & Web', to: '/services/branding' },
    { label: 'Web Development', to: '/services/web-development' },
  ];

  const quickLinks = [
    { label: 'Home', to: '/' },
    { label: 'About', to: '/about' },
    { label: 'Pricing', to: '/pricing' },
    { label: 'Blog', to: '/blog' },
    { label: 'Contact', to: '/contact' },
  ];

  const socials = [
    { icon: 'fa-brands fa-instagram', href: 'https://www.instagram.com/grandframe.in', label: 'Instagram' },
    { icon: 'fa-brands fa-linkedin-in', href: 'https://www.linkedin.com/company/grandframe', label: 'LinkedIn' },
    { icon: 'fa-brands fa-facebook-f', href: 'https://www.facebook.com/grandframe.in', label: 'Facebook' },
    { icon: 'fa-brands fa-whatsapp', href: 'https://wa.me/919562001221', label: 'WhatsApp' },
  ];

  return (
    <footer style={{
      background: 'linear-gradient(180deg, #080F1C 0%, #0A1525 100%)',
      borderTop: '1px solid rgba(255, 92, 0, 0.12)',
      marginTop: '6rem',
      position: 'relative',
      overflow: 'hidden',
    }}>

      {/* Top ambient glow */}
      <div style={{
        position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)',
        width: '700px', height: '2px',
        background: 'linear-gradient(90deg, transparent, rgba(255,92,0,0.5), transparent)',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', top: '-80px', left: '50%', transform: 'translateX(-50%)',
        width: '500px', height: '200px',
        background: 'radial-gradient(ellipse, rgba(255,92,0,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      {/* ── CTA Strip ── */}
      <div style={{
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        padding: '3.5rem 0',
      }}>
        <div className="container" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '2rem',
          flexWrap: 'wrap',
        }}>
          <div>
            <p style={{ color: '#94A3B8', fontSize: '0.85rem', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.4rem' }}>
              Ready to grow your business?
            </p>
            <h3 style={{
              fontFamily: 'var(--font-head)',
              fontSize: 'clamp(1.4rem, 2.5vw, 2rem)',
              color: '#F8FAFC',
              fontWeight: 700,
              margin: 0,
              lineHeight: 1.3,
            }}>
              Let's build something <span style={{ color: '#FF5C00' }}>extraordinary</span> together.
            </h3>
          </div>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <Link to="/contact" style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
              padding: '0.8rem 1.8rem',
              borderRadius: '50px',
              background: 'linear-gradient(135deg, #FF5C00, #FF8C42)',
              color: '#fff',
              fontFamily: 'var(--font-head)',
              fontWeight: 700,
              fontSize: '0.95rem',
              textDecoration: 'none',
              boxShadow: '0 4px 20px rgba(255,92,0,0.35)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 30px rgba(255,92,0,0.5)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(255,92,0,0.35)'; }}
            >
              Start a Project <i className="fa-solid fa-arrow-right"></i>
            </Link>
            <a href="tel:+919562001221" style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
              padding: '0.8rem 1.8rem',
              borderRadius: '50px',
              background: 'transparent',
              color: '#CBD5E1',
              fontFamily: 'var(--font-head)',
              fontWeight: 600,
              fontSize: '0.95rem',
              textDecoration: 'none',
              border: '1px solid rgba(255,255,255,0.15)',
              transition: 'border-color 0.2s ease, color 0.2s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,92,0,0.5)'; e.currentTarget.style.color = '#FF7A2F'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'; e.currentTarget.style.color = '#CBD5E1'; }}
            >
              <i className="fa-solid fa-phone"></i> +91 9562 001221
            </a>
          </div>
        </div>
      </div>

      {/* ── Main Footer Grid ── */}
      <div className="container" style={{ padding: '4rem 2rem 3rem' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1fr',
          gap: '3rem',
        }} className="footer-main-grid">

          {/* Brand column */}
          <div>
            {/* Logo */}
            <div style={{ marginBottom: '1.25rem' }}>
              <Link to="/">
                <img
                  src="/logo.svg"
                  alt="Grandframe Creative Digital"
                  style={{
                    height: '48px',
                    maxWidth: '180px',
                    width: 'auto',
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
              </Link>
            </div>

            <p style={{
              color: '#64748B',
              fontSize: '0.95rem',
              lineHeight: '1.75',
              maxWidth: '280px',
              marginBottom: '1.75rem',
            }}>
              Digital growth and creative solutions designed to drive real engagement and operational productivity.
            </p>

            {/* Badges */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1.75rem' }}>
              {['Meta Ads Partner', 'Google Certified', 'Kerala-Based'].map(b => (
                <span key={b} style={{
                  display: 'inline-block',
                  padding: '0.3rem 0.75rem',
                  borderRadius: '50px',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  color: '#94A3B8',
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  letterSpacing: '0.02em',
                }}>{b}</span>
              ))}
            </div>

            {/* Social icons */}
            <div style={{ display: 'flex', gap: '0.6rem' }}>
              {socials.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}
                  style={{
                    width: '38px', height: '38px', borderRadius: '10px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    color: '#64748B',
                    fontSize: '0.95rem',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,92,0,0.12)'; e.currentTarget.style.color = '#FF5C00'; e.currentTarget.style.borderColor = 'rgba(255,92,0,0.3)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; e.currentTarget.style.color = '#64748B'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 style={{
              fontFamily: 'var(--font-head)',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: '#FF5C00',
              marginBottom: '1.25rem',
            }}>Services</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.7rem' }}>
              {services.map(s => (
                <li key={s.to}>
                  <Link to={s.to} style={{
                    color: '#64748B',
                    fontSize: '0.95rem',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.4rem',
                    transition: 'color 0.2s ease, gap 0.2s ease',
                  }}
                    onMouseEnter={e => { e.currentTarget.style.color = '#F1F5F9'; e.currentTarget.style.gap = '0.6rem'; }}
                    onMouseLeave={e => { e.currentTarget.style.color = '#64748B'; e.currentTarget.style.gap = '0.4rem'; }}
                  >
                    <i className="fa-solid fa-chevron-right" style={{ fontSize: '0.6rem', color: '#FF5C00', opacity: 0.7 }}></i>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontFamily: 'var(--font-head)',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: '#FF5C00',
              marginBottom: '1.25rem',
            }}>Company</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.7rem' }}>
              {quickLinks.map(l => (
                <li key={l.to}>
                  <Link to={l.to} style={{
                    color: '#64748B',
                    fontSize: '0.95rem',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.4rem',
                    transition: 'color 0.2s ease, gap 0.2s ease',
                  }}
                    onMouseEnter={e => { e.currentTarget.style.color = '#F1F5F9'; e.currentTarget.style.gap = '0.6rem'; }}
                    onMouseLeave={e => { e.currentTarget.style.color = '#64748B'; e.currentTarget.style.gap = '0.4rem'; }}
                  >
                    <i className="fa-solid fa-chevron-right" style={{ fontSize: '0.6rem', color: '#FF5C00', opacity: 0.7 }}></i>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{
              fontFamily: 'var(--font-head)',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: '#FF5C00',
              marginBottom: '1.25rem',
            }}>Get In Touch</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <li style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                <i className="fa-solid fa-envelope" style={{ color: '#FF5C00', marginTop: '3px', fontSize: '0.9rem', flexShrink: 0 }}></i>
                <a href="mailto:contact@grandframe.in" style={{ color: '#64748B', fontSize: '0.9rem', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#FF7A2F'}
                  onMouseLeave={e => e.currentTarget.style.color = '#64748B'}
                >contact@grandframe.in</a>
              </li>
              <li style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                <i className="fa-solid fa-phone" style={{ color: '#FF5C00', marginTop: '3px', fontSize: '0.9rem', flexShrink: 0 }}></i>
                <a href="tel:+919562001221" style={{ color: '#64748B', fontSize: '0.9rem', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#FF7A2F'}
                  onMouseLeave={e => e.currentTarget.style.color = '#64748B'}
                >+91 9562 001221</a>
              </li>
              <li style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                <i className="fa-solid fa-location-dot" style={{ color: '#FF5C00', marginTop: '3px', fontSize: '0.9rem', flexShrink: 0 }}></i>
                <span style={{ color: '#64748B', fontSize: '0.9rem', lineHeight: 1.6 }}>
                  Kalarcode, Alappuzha, Kerala 688003<br />
                  <span style={{ color: '#475569', fontSize: '0.82rem' }}>Kaithavana, Alappuzha - Changanassery Hwy</span>
                </span>
              </li>
              <li style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                <i className="fa-solid fa-clock" style={{ color: '#FF5C00', marginTop: '3px', fontSize: '0.9rem', flexShrink: 0 }}></i>
                <span style={{ color: '#64748B', fontSize: '0.9rem', lineHeight: 1.6 }}>
                  Mon – Sat<br />
                  <span style={{ color: '#475569', fontSize: '0.82rem' }}>9:00 AM – 6:00 PM IST</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.06)',
        padding: '1.5rem 0',
      }}>
        <div className="container" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '1rem',
          flexWrap: 'wrap',
        }}>
          <p style={{ color: '#334155', fontSize: '0.85rem', margin: 0 }}>
            © {year} <span style={{ color: '#475569' }}>Grandframe Creative Digital.</span> All Rights Reserved.
          </p>
          <p style={{ color: '#334155', fontSize: '0.82rem', margin: 0 }}>
            Crafted with ♥ in Kerala, India
          </p>
        </div>
      </div>

      {/* Responsive styles */}
      <style>{`
        @media (max-width: 1024px) {
          .footer-main-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 2.5rem !important;
          }
        }
        @media (max-width: 640px) {
          .footer-main-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
